var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.63158 10.1316C4.63158 10.3619 4.72307 10.5828 4.88593 10.7456C5.04879 10.9085 5.26968 11 5.5 11C5.73032 11 5.95121 10.9085 6.11407 10.7456C6.27693 10.5828 6.36842 10.3619 6.36842 10.1316V6.36842H10.1316C10.3619 6.36842 10.5828 6.27693 10.7456 6.11407C10.9085 5.95121 11 5.73032 11 5.5C11 5.26968 10.9085 5.04879 10.7456 4.88593C10.5828 4.72307 10.3619 4.63158 10.1316 4.63158H6.36842V0.868421C6.36842 0.638101 6.27693 0.417215 6.11407 0.254355C5.95121 0.0914941 5.73032 0 5.5 0C5.26968 0 5.04879 0.0914941 4.88593 0.254355C4.72307 0.417215 4.63158 0.638101 4.63158 0.868421V4.63158H0.868421C0.638101 4.63158 0.417215 4.72307 0.254355 4.88593C0.0914941 5.04879 0 5.26968 0 5.5C0 5.73032 0.0914941 5.95121 0.254355 6.11407C0.417215 6.27693 0.638101 6.36842 0.868421 6.36842H4.63158V10.1316Z",
    fill: "#3D4AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/add_new.977a7e879dfaffb04da04c79a85370a7.svg";
export { ForwardRef as ReactComponent };